import { init as initFavoriteBusHandler } from '@organisms/favorite-bus-handler';
import { init as initProposalBusHandler } from '@organisms/proposal-bus-handler';

export const initSelectionBusHandler = () => {
  initFavoriteBusHandler();
  initProposalBusHandler();
};
